import { put, takeEvery, call } from '@redux-saga/core/effects';
import {
  get_groups,
  get_groups_error,
  get_groups_success,
  delete_group_success,
  delete_group_error,
  delete_group,
  get_group_invites,
  get_group_invites_error,
  get_group_invites_success,
  join_group,
  join_group_error,
  join_group_success,
} from './reducer';

import api from '@service/DataService';
import toast from 'react-hot-toast';

function* getGroupsSaga({ payload }) {
  try {
    const { page = 1, limit = 10 } = payload;
    const requestRes = yield call(
      api.get,
      `/groups/byuser?&page=${page}&limit=${limit}`,
    );
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_groups_success.type,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: get_groups_error.type,
    });
  }
}

function* getInvitesSaga() {
  try {
    const requestRes = yield call(api.get, `/group_invites/byuser`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_group_invites_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_group_invites_error.type,
    });
  }
}

function* joinGroupSaga({ payload }) {
  try {
    const requestRes = yield call(api.post, `/group_members/join/${payload._id}`);
    const responseData = requestRes.data;
    toast.success(responseData.message);
    yield put({
      type: join_group_success.type,
      payload,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: join_group_error.type,
    });
  }
}

function* deleteGroupSaga({ payload }) {
  try {
    const requestRes = yield call(api.delete, `/groups/${payload}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(response.message);
    window.location.href = '/baskets';
    yield put({
      type: delete_group_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: delete_group_error.type,
    });
  }
}

function* groupsSagas() {
  yield takeEvery(get_groups.type, getGroupsSaga);
  yield takeEvery(delete_group.type, deleteGroupSaga);
  yield takeEvery(join_group_success.type, getGroupsSaga);
  yield takeEvery(get_group_invites.type, getInvitesSaga);
  yield takeEvery(join_group.type, joinGroupSaga);
}

export default groupsSagas;
